$(document).ready(function () {
  var $body = $("body"),
    headerHeight = $(".header").outerHeight();

  // Smooth scroll
  $("a.smooth-scroll").on("click", function (e) {
    var $this = $(this),
      target = $this.attr("href"),
      $target = $(target);

    e.preventDefault();

    $("html, body").animate(
      {
        scrollTop: $target.offset().top - headerHeight,
      },
      1000,
      function () {
        // Callback after animation
        // Must change focus!
        $target.focus();
        if ($target.is(":focus")) {
          // Checking if the target was focused
          return false;
        } else {
          $target.attr("tabindex", "-1"); // Adding tabindex for elements not focusable
          $target.focus(); // Set focus again
        }
      }
    );
  });

  const carouselSettings = {
    featureThreeColCarousel: {
      infinite: true,
      dots: false,
      variableWidth: false,
      slide: ".carousel__slide",
      centerMode: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      mobileFirst: true,
      prevArrow:
        '<div class="carousel--prev"><svg width="10" height="17" viewBox="0 0 10 17" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9.14286 1L2 8.5L9.14286 16" stroke="black" stroke-width="1.5"/></svg></div>',
      nextArrow:
        '<div class="carousel--next"><svg width="10" height="17" viewBox="0 0 10 17" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.857143 16L8 8.5L0.857144 0.999999" stroke="black" stroke-width="1.5"/></svg></div>',
      responsive: [
        {
          breakpoint: 768,
          settings: {
            centerMode: false,
            slidesToShow: 2,
            swipe: false,
          },
        },
      ],
    },
    bannerThreeColCarousel: {
      infinite: true,
      dots: false,
      autoplay: false,
      slide: ".carousel__slide",
      slidesToShow: 1,
      slidesToScroll: 1,
      mobileFirst: true,
      prevArrow:
        '<div class="carousel--prev"><svg width="10" height="17" viewBox="0 0 10 17" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9.14286 1L2 8.5L9.14286 16" stroke="white" stroke-width="1.5"/></svg></div>',
      nextArrow:
        '<div class="carousel--next"><svg width="10" height="17" viewBox="0 0 10 17" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.857143 16L8 8.5L0.857144 0.999999" stroke="white" stroke-width="1.5"/></svg></div>',
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
          },
        },
      ],
    },
    collectionFiveColCarousel: {
      infinite: true,
      dots: false,
      autoplay: false,
      variableWidth: false,
      slide: ".carousel__slide",
      slidesToShow: 1,
      slidesToScroll: 1,
      centerMode: true,
      mobileFirst: true,
      prevArrow:
        '<div class="carousel--prev"><svg width="10" height="17" viewBox="0 0 10 17" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9.14286 1L2 8.5L9.14286 16" stroke="black" stroke-width="1.5"/></svg></div>',
      nextArrow:
        '<div class="carousel--next"><svg width="10" height="17" viewBox="0 0 10 17" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.857143 16L8 8.5L0.857144 0.999999" stroke="black" stroke-width="1.5"/></svg></div>',
      responsive: [
        {
          breakpoint: 768,
          settings: {
            centerMode: false,
            slidesToShow: 2,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 1200,
          settings: {
            centerMode: false,
            slidesToShow: 5,
            slidesToScroll: 5,
          },
        },
      ],
    },
  };

  $(".banner__three__col__carousel").each(function () {
    $(this).slick(carouselSettings.bannerThreeColCarousel);
  });

  $(".collection__five__col__carousel").each(function () {
    $(this).slick(carouselSettings.collectionFiveColCarousel);
  });

  $(".feature__three__col__carousel").each(function () {
    $(this).slick(carouselSettings.featureThreeColCarousel);
  });
  
});


